"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryCardFields = BasisTheoryCardFields;
var _react = _interopRequireDefault(require("react"));
var CVV_ICON = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "26",
  height: "18",
  viewBox: "0 0 26 18",
  fill: "none",
  "aria-hidden": "true"
}, /*#__PURE__*/_react["default"].createElement("rect", {
  x: "0.5",
  y: "0.5",
  width: "25",
  height: "17",
  rx: "2.5",
  fill: "white",
  stroke: "#D1D5DB"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  y: "3",
  width: "26",
  height: "4",
  fill: "#374151"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  x: "2",
  y: "9",
  width: "16",
  height: "3",
  rx: "1",
  fill: "#F3F4F6",
  stroke: "#D1D5DB"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  x: "19",
  y: "9",
  width: "5",
  height: "3",
  rx: "1",
  fill: "white",
  stroke: "var(--color-error)"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "20",
  cy: "10.5",
  r: "0.6",
  fill: "var(--color-error)"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "21.7",
  cy: "10.5",
  r: "0.6",
  fill: "var(--color-error)"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "23.4",
  cy: "10.5",
  r: "0.6",
  fill: "var(--color-error)"
}));
var REQUIRED_MARK = /*#__PURE__*/_react["default"].createElement("span", {
  className: "ml-0.5 font-semibold text-error-regular",
  "aria-hidden": "true"
}, "*");

/**
 * BasisTheoryCardFields component.
 *
 * Render secure card element containers and the cardholder input.
 *
 * @param {object} props - Component props.
 * @param {string} props.holderName - Current cardholder name.
 * @param {Function} props.onHolderNameChange - Cardholder input change handler.
 * @param {Function} props.t - Translation function.
 * @returns {React.ReactElement} Card fields.
 */
function BasisTheoryCardFields(_ref) {
  var holderName = _ref.holderName,
    onHolderNameChange = _ref.onHolderNameChange,
    t = _ref.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap gap-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex basis-full flex-col gap-1.5 md:flex-[5] md:basis-0"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm text-gray-500"
  }, t('purchase:label.bt_form.card_number_label'), REQUIRED_MARK), /*#__PURE__*/_react["default"].createElement("div", {
    id: "bt-card-number",
    className: "flex h-[46px] cursor-text items-center rounded-[10px] border border-gray-200 px-3 focus-within:border-accent-regular focus-within:ring-2 focus-within:ring-accent-regular/50 md:h-[50px] md:rounded-xl"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-[2.5] basis-[calc(50%_-_6px)] flex-col gap-1.5 md:basis-0"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm text-gray-500"
  }, t('purchase:label.bt_form.expiration_label'), REQUIRED_MARK), /*#__PURE__*/_react["default"].createElement("div", {
    id: "bt-card-expiration",
    className: "flex h-[46px] cursor-text items-center rounded-[10px] border border-gray-200 px-3 focus-within:border-accent-regular focus-within:ring-2 focus-within:ring-accent-regular/50 md:h-[50px] md:rounded-xl"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-[2.5] basis-[calc(50%_-_6px)] flex-col gap-1.5 md:basis-0"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm text-gray-500"
  }, t('purchase:label.bt_form.cvv_label'), REQUIRED_MARK), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "bt-card-cvc",
    className: "flex h-[46px] w-full cursor-text items-center rounded-[10px] border border-gray-200 py-0 pl-3 pr-[38px] focus-within:border-accent-regular focus-within:ring-2 focus-within:ring-accent-regular/50 md:h-[50px] md:rounded-xl"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pointer-events-none absolute right-2 top-1/2 flex -translate-y-1/2 items-center justify-center"
  }, CVV_ICON)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-1.5 md:max-w-[calc(50%_-_6px)]"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "text-sm text-gray-500",
    htmlFor: "bt-holder-name"
  }, t('purchase:label.bt_form.holder_name_label'), REQUIRED_MARK), /*#__PURE__*/_react["default"].createElement("input", {
    id: "bt-holder-name",
    "aria-label": t('purchase:label.bt_form.holder_name_label'),
    className: "h-[46px] w-full rounded-[10px] border border-gray-200 px-3 text-base text-gray-500 outline-none placeholder:text-gray-300 focus:border-accent-regular focus:ring-2 focus:ring-accent-regular/50 md:h-[50px] md:rounded-xl",
    type: "text",
    autoComplete: "cc-name",
    placeholder: t('purchase:label.bt_form.holder_name_placeholder'),
    value: holderName,
    onChange: onHolderNameChange
  })));
}